import Image from 'next/image';

import styles from '@styles/dropAuction/howItWork.module.scss';
import {useApp} from '@context/AppProvider';

const StepTwo = () => {
	const {convertCurrency} = useApp();
	return (
		<div className='col-sm-4'>
			<div className={styles.stepTwo}>
				<div className={styles.stepBidBox}>
					<Image
						width={310}
						height={310}
						src='/assets/images/cricle-bg.png'
						alt='image'
					/>
					<div className={styles.stepBidTxt}>
						<div className={styles.stepNumber}>2</div>
						<div className={styles.stepBidInner}>
							<span>{convertCurrency(83.68)}</span>
							<Image
								width={200}
								height={83}
								src='https://s3.us-west-004.backblazeb2.com/betterthat/index/shoe-200x83.png'
								alt='shoe'
							/>
							<span className={styles.seeBtnAction}>Bid Now</span>
						</div>
					</div>
				</div>
				<div className={styles.stepText}>
					<h2>Place Your Bid</h2>
					<p>
						Once you’ve chosen, place your bid and secure your spot in the
						auction.
					</p>
					<p>Now, you’re in the game— let the thrill of bidding begin!</p>
				</div>
			</div>
		</div>
	);
};

export default StepTwo;
